
import store from '@/store';
import {
  computed, defineComponent,
} from '@vue/composition-api';

export default defineComponent({
  setup() {
    const network = computed(() => store.state.network);

    const selectedNodes = computed(() => store.state.selectedNodes);
    function clearSelection() {
      store.commit.setSelected(new Set());
    }
    function pinSelectedNodes() {
      if (network.value !== null) {
        network.value.nodes
          .filter((node) => selectedNodes.value.has(node._id))
          .forEach((node) => {
            // eslint-disable-next-line no-param-reassign
            node.fx = node.x;
            // eslint-disable-next-line no-param-reassign
            node.fy = node.y;
          });
      }
    }
    function unPinSelectedNodes() {
      if (network.value !== null) {
        network.value.nodes
          .filter((node) => selectedNodes.value.has(node._id))
          .forEach((node) => {
            // eslint-disable-next-line no-param-reassign
            delete node.fx;
            // eslint-disable-next-line no-param-reassign
            delete node.fy;
          });
      }
    }

    const rightClickMenu = computed(() => store.state.rightClickMenu);

    return {
      rightClickMenu,
      clearSelection,
      pinSelectedNodes,
      unPinSelectedNodes,
    };
  },
});
